export const NoStartDateMonthLimit = 4;
export const DateFlexibility = 14;
export const MaxBedroomCount = 8;
export const ShortRangeRentThreshold = 28;
